import React, { useState, useEffect } from "react";
import FormSection from "components/sales/formSection/formSection";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import Regex from "services/utils/regex/Regex";
import localization from "assets/localization/localization";

const LaneDetails = ({ handleValue }) => {
  const laneDetails = {
    no_of_lanes_entry: "",
    no_of_lanes_exit: "",
  };

  const [laneDetailsData, setlaneDetailsData] = useState(laneDetails);

  const handleFormData = () => {
    if (
      (laneDetailsData.no_of_lanes_entry !== "" || laneDetailsData.no_of_lanes_entry !== 0)  &&
     ( laneDetailsData.no_of_lanes_exit !== "" || laneDetailsData.no_of_lanes_exit !== 0)
    ) {
      handleValue({
        ...laneDetailsData,
      });
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handleFormData();
  }, [laneDetailsData]);

  return (
    <FormSection title={localization.laneDetailsTitle}>
      <ConstantInput
        label={localization.laneEntry}
        regex={Regex.numericNotZero.test(laneDetailsData.no_of_lanes_entry)}
        errorMsg={
          laneDetailsData.no_of_lanes_entry
            ? localization.numericErrorMg
            : localization.requiredLanesEntry
        }
        type="text"
        handleChange={(val) => {
          setlaneDetailsData({ ...laneDetailsData, no_of_lanes_entry: val.replace(/^0+/, "") });
        }}
        isNotZero 
      />

      <ConstantInput
        label={localization.laneExit}
        regex={Regex.numericNotZero.test(laneDetailsData.no_of_lanes_exit)}
        errorMsg={
          laneDetailsData.no_of_lanes_exit
            ? localization.numericErrorMg
            : localization.requiredLanesExit
        }
        type="text"
        handleChange={(val) => {
          setlaneDetailsData({ ...laneDetailsData, no_of_lanes_exit:  val.replace(/^0+/, "") });
        }}
        isNotZero 
        
      />
    </FormSection>
  );
};

export default LaneDetails;
